import { LitElement, html, svg } from 'lit';

export class IconGraphPie32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Kakediagram</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M30 14H18V2a12 12 0 0 1 12 12Z"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M14 6a12 12 0 1 0 12 12H14V6Z"></path></svg>`; }
}
if (!customElements.get('f-icon-graph-pie32', IconGraphPie32)) {
  customElements.define('f-icon-graph-pie32', IconGraphPie32);
}